// Canonical invitation status values shared by LeMans Home UI and Common Admin.
export enum InvitationsStatus {
  ACCEPTED = 'Accepted',
  ACCEPTEDALERT = 'AcceptedAlert',
  ABORTED = 'Aborted',
  INVALID = 'Invalid',
  EXPIRED = 'Expired',
  ACTIVE = 'Active',
}
